import {FileServiceRequests} from '@canvas-logic/configurator-base/lib/requests/file-service-requests';
import * as env from 'env-var';

const fileServiceRequests = new FileServiceRequests(
  env.get('REACT_APP_CL__CAN_FILE_SERVICE_HOST').required().asString(),
  env.get('REACT_APP_CL__CAN_FILE_SERVICE_API_KEY').required().asString(),
);

export const getFileServiceRequests = () => fileServiceRequests;